import { create } from "zustand";
import { Album, Playlist, Track } from "../types";
import { useLocalLibraryStore } from "./localLibraryStore";

export type SidebarContent = "haptics" | "equalizer" | "addToPlaylist" | "addToAlbum" | null;

interface RightSidebarState {
  isOpen: boolean;
  content: SidebarContent;
  selectedTrack: Track | null;
  openSidebar: (content: SidebarContent, track?: Track) => void;
  closeSidebar: () => void;
  getPlaylists: () => Playlist[];
  getAlbums: () => Album[];
  addTrackToPlaylist: (playlistId: string) => void;
  addTrackToAlbum: (albumId: string) => void;
}

export const useRightSidebarStore = create<RightSidebarState>((set, get) => ({
  isOpen: false,
  content: null,
  selectedTrack: null,
  openSidebar: (content, track = null) => set({ isOpen: true, content, selectedTrack: track }),
  closeSidebar: () => set({ isOpen: false, content: null, selectedTrack: null }),
  getPlaylists: () => {
    const localLibrary = useLocalLibraryStore.getState();
    return localLibrary.getAllPlaylists();
  },
  getAlbums: () => {
    const localLibrary = useLocalLibraryStore.getState();
    return localLibrary.getAllAlbums();
  },
  addTrackToPlaylist: (playlistId: string) => {
    const { selectedTrack } = get();
    if (selectedTrack) {
      const localLibrary = useLocalLibraryStore.getState();
      localLibrary.addTrackToPlaylist(playlistId, selectedTrack);
    }
  },
  addTrackToAlbum: (albumId: string) => {
    const { selectedTrack } = get();
    if (selectedTrack) {
      const localLibrary = useLocalLibraryStore.getState();
      localLibrary.addTrackToAlbum(albumId, selectedTrack);
    }
  },
}));
